import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper/index";
// import GetAllFormFields from '../../../components/_utils/formUtils'
import moment from "moment";
import { Button, Card, Drawer, Form, Icon, Select, Table, Tabs } from "antd";
import _ from "lodash";
import S from "string";
import StudentHeader from "../../../components/studentHeader/index";

import Request from "../../../request";
import { connect } from "react-redux";
import StudentInfo from "../../../components/StudentInfo";
import renderHTML from "react-render-html";
import { TableComp } from "sz-react-utils";

const Option = Select.Option;

const TabPane = Tabs.TabPane;
const config = {
  rules: [{ type: "object", required: true, message: "Please select time!" }],
};

// following variables needed for update country
let docLoaded = null;
let countryId = null;

@Form.create()
class RatingHistory extends PureComponent {
  state = {
    studentId: "",
    count: 0,
    ratingHistoryArr: [],
  }
  constructor(props) {
    super(props);
    this.table = React.createRef();
  }

  async componentDidMount() {
    let searchParams = new URLSearchParams(this.props.search);

    let studentId = searchParams.get("id");
    let { doc } = await Request.getInquiry(studentId);
    this.setState({ completeInfo: doc });
    let ratingHistoryArr = [];
    if(doc && doc.counsellingDesk && doc.counsellingDesk.ratingHistory && doc.counsellingDesk.ratingHistory.length > 0) {
      doc.counsellingDesk.ratingHistory.map((history) => {
        ratingHistoryArr.push({
          ratingName: history.ratingName,
          subRatingName: history.subRatingName,
          updatedByUser: history.updatedByUser
        })
      });
      this.setState({ratingHistoryArr});
    }
  }

  render() {
    const { submitting } = this.props;
    const { dispatch } = this.props;
    const { completeInfo } = this.state;

    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
    } = this.props;

    const columns = [
      {
        title: "Rating",
        key: "ratingName",
        width: 150,
      },
      {
        title: "Sub Rating",
        key: "subRatingName",
      },
      {
        title: "Done By",
        key: "updatedByUser.name",
        dataIndex: "updatedByUser.name",
        width: 150,
        render: (val, record) => {
          return (
            <div>{record.updatedByUser && record.updatedByUser.name} </div>
          );
        },
      },
      {
        title: "Date",
        key: "updatedByUser.time",
        dataIndex: "updatedByUser.time",
        width: 150,
        render: (val, record) => {
          return (
            <div>
              {record.updatedByUser
                ? moment(record.updatedByUser.time).format(
                    "DD-MMM-YYYY hh:mm:A"
                  )
                : "NA"}
            </div>
          );
        },
      }
    ];

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 },
      },
    };

    const submitFormLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 10, offset: 7 },
        md: { span: 12, offset: 8 },
      },
    };

    return (
      <PageHeaderWrapper title={"Rating History"}>
        {completeInfo ? (
          <div style={{ marginBottom: 10 }}>
            <StudentHeader
              info={this.state.studentId}
              data={this.state.completeInfo}
              done={() => {}}
              dispatch={this.props.dispatch}
            />
          </div>
        ) : null}

        {completeInfo ? (
          <Card bordered={true} style={{ marginBottom: 10 }}>
            <StudentInfo info={completeInfo} />
          </Card>
        ) : null}

        <Card bordered={true}>
          <TableComp
            columns={columns}
            id={"desk-activities"}
            showSelector={true}
            ref={this.table}
            dataSource={this.state.ratingHistoryArr}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 50,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
          }}
            bordered
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RatingHistory);
